module.exports = __webpack_public_path__ + "static/media/clock.0b27525e.jpg";